import { formatMessage } from "@flixbus-phx/marketplace-common";
import { SortDirection, SortField } from "../../../../shared/types/schema";
import { RideSort } from "../../../../state/useRideSort/useRideSort";

export default (rideSort: RideSort) => {
  const labels = {
    [SortField.Departure]: {
      [SortDirection.Asc]: formatMessage("ride.sort.option.dateAsc"),
      [SortDirection.Desc]: formatMessage("ride.sort.option.dateDsc"),
    },
    [SortField.NumberOfPax]: {
      [SortDirection.Asc]: formatMessage("ride.sort.option.numberOfPassengersAsc"),
      [SortDirection.Desc]: formatMessage("ride.sort.option.numberOfPassengersDsc"),
    },
  };

  return labels[rideSort.field]?.[rideSort.direction] || formatMessage("ride.sort.option.dateAsc");
};
